// =================================================================
// RequireSuperAdmin
//
// Guards pages that only the super-admin can access:
//   - /admin/communities (list/create communities)
//   - /admin/catalog (the games catalog reference)
//
// Community admins are redirected to their own roster (or picker
// if multi-community) so they don't hit a dead end.
// =================================================================

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/useAuth.jsx';
import { useAdminAccess } from '../lib/useAdminAccess.jsx';

export default function RequireSuperAdmin({ children }) {
  const { user, loading: authLoading } = useAuth();
  const { isSuperAdmin, communities, loading: accessLoading } = useAdminAccess();
  const location = useLocation();

  if (authLoading || accessLoading) {
    return (
      <div className="container" style={{ paddingTop: '4rem' }}>
        <p style={{
          fontFamily: 'var(--font-serif)',
          fontStyle: 'italic',
          color: 'var(--ink-faded)',
        }}>
          Checking your sign-in…
        </p>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ returnTo: location.pathname }}
      />
    );
  }

  if (!isSuperAdmin) {
    // Community admin trying to reach a super-admin-only page.
    // Send them to the most helpful destination based on how many
    // communities they admin.
    if (communities.length === 1) {
      return (
        <Navigate
          to={`/admin/communities/${encodeURIComponent(communities[0].code)}/residents`}
          replace
        />
      );
    }
    if (communities.length > 1) {
      return <Navigate to="/admin/picker" replace />;
    }
    return <Navigate to="/admin/no-access" replace />;
  }

  return children;
}
